import { donationsApi } from '../api/donationsApi'

export const getDonations = async () => {
  try {
    const {
      data: { donations },
    } = await donationsApi.getDonations()
    return donations
  } catch (error) {
    console.error(`Error fetching donations: `, error)
    throw error
  }
}
